// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseRelationshipModel {
    static getAttributeTypeMap() {
        return CaseRelationshipModel.attributeTypeMap;
    }
}
CaseRelationshipModel.discriminator = undefined;
CaseRelationshipModel.attributeTypeMap = [
    {
        "name": "partyRoleId",
        "baseName": "partyRoleId",
        "type": "number"
    },
    {
        "name": "isPrimary",
        "baseName": "isPrimary",
        "type": "boolean"
    }
];
//# sourceMappingURL=caseRelationshipModel.js.map